module.exports = __webpack_public_path__ + "chat-white-i.png";